<template>
  <div>
      <div class="mb-1">
        <div class="loader" v-if="loading"></div>
        <template v-for="comment in commentsList" v-if="commentsLoaded">


        <comment :key="comment.comment.id" :userImage="comment.comment.profile_image"
                 :userName="comment.comment.account"
                 :text="comment.comment.body" :date="formatDate(comment.comment.created_at)"
        />
        </template>
        <hr>
        <b-media no-body class="align-items-center">
          <b-img rounded="circle" alt="Image placeholder" class="avatar avatar-lg mr-4" :src="currentAccount.profile_img" />
          <b-media-body >
            <b-input placeholder="Comment here..." v-model="body" @keyup.enter.native="postComment(this)"/>
          </b-media-body>
        </b-media>
      </div>
    </div>

</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
  name: "comments",
  components: {
    Comment
  },
  props: {
    commentable_type: '',
    commentable_id: 0,
    comment_id: 0,
  },
  data() {
    return {
      loading: false,
      commentsList: [],
      body: '',
    };
  },
  methods: {
    retrieveComments() {
      this.commentsList = [];
      this.loading = true;
      this.$api.getComments(this.commentable_type,this.commentable_id)
        .then((response) => {
          this.commentsList = response.data.comments;
          console.log(this.commentsList);
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false
        });
    },
    retrieveComment(id) {
      this.loading = true;
      let query = {};
      query["commentable_type"] = this.commentable_type;
      query["commentable_id"] = this.commentable_id;
      query["id"] = id;
      this.$api.getComment(query)
        .then((response) => {
          this.commentsList.push(response.data.comment);
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false
        });
    },
    postComment() {
    let comment = {};
    comment["commentable_type"] = this.commentable_type;
    comment["commentable_id"] = this.commentable_id;
    comment["body"] = this.body;
      this.loading = true;
      this.$api.setComment(comment)
        .then((response) => {
          this.commentsList.push(response.data);
          this.body = '';
        })
        .catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false
        });
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY")
    },
  },
  /*
  channels: {
    CommentsChannel: {
      connected() {
        //console.log('I am connected.');
      },
      rejected() {
      //console.log('I am REJECTED.');
      },
      received(data) {
        //console.log("RECEIVED!");
        //console.log(data);
        this.commentsList.push(data.comment);
      },
      disconnected() {
      //console.log('I am disconnected.');
      }
    }
  },
  */
  computed: {
    ...mapGetters({ currentAccount: 'currentAccount' }),
    commentsLoaded: function(){
        return this.commentsList ? true : false;
    }
  },
  watch: {
    commentable_id(newValue, oldValue) {
      console.log('queryParameter commentable_id changed from: ' + oldValue + ' -> ' + newValue);
      this.retrieveComments();
      // redirect if needed -> dashboard
    },
  },
  mounted() {
    /*
    this.$cable.subscribe({
      channel: 'CommentsChannel',
      commentable_type: this.commentable_type,
      commentable_id: this.commentable_id,
    });
    */
    this.retrieveComments();
  },
};
</script>
<style>
</style>